import Vue from 'vue'
import Router from 'vue-router'
// Import Components
import Hello from '@/components/Hello'
import HelloWorld from '@/components/HelloWorld'
import GatherUserInfo from '@/components/GatherUserInfo'
import Login from '@/components/Login'
/* FutureEvents / Događaji */
import FutureEvents from '@/components/futureEvents/FutureEvents'
/* FutureEvents - Single Event / Događaji - Pojedinacni događaj */
//import EventReservations from '@/components/futureEvents/EventReservations'
/* EventsArchive / Arhiva događaja */
import EventsArchive from '@/components/eventsArchive/EventsArchive'
/* RegularGuests / Stalni gosti */
import RegularGuests from '@/components/regularGuests/RegularGuests'
/* WaitersList / Konobari */
import WaitersList from '@/components/waiters/WaitersList'
/* VenuesList / Grupe stolova */
import VenuesList from '@/components/venueTypes/VenuesList'
/* AdminsList / Administratori */
import AdminsList from '@/components/adminsList/AdminsList'
/* LogsHistory / Istorija izmena */
import LogsHistory from '@/components/logs/LogsHistory'
// import Firebase
import Firebase from 'firebase'


Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { headerTitle: 'Ulogujte se' }
    },
    {
      path: '/gather-user-info',
      name: 'GatherUserInfo',
      component: GatherUserInfo,
      meta: {
        requiresAuth: true, headerTitle: 'Osvežavanje korisničkih informacija'
      }
    },
    {
      path: '/future-events',
      name: 'FutureEvents',
      component: FutureEvents,
      meta: { requiresAuth: true, headerTitle: 'Lista zakazanih događaja' }
    },
    {
      path: '/events-archive',
      name: 'EventsArchive',
      component: EventsArchive,
      meta: { requiresAuth: true, headerTitle: 'Arhiva događaja' }
    },
    {
      path: '/regular-guests',
      name: 'RegularGuests',
      component: RegularGuests,
      meta: { requiresAuth: true, headerTitle: 'Stalni gosti' }
    },
    {
      path: '/waiters-list',
      name: 'WaitersList',
      component: WaitersList,
      meta: { requiresAuth: true, headerTitle: 'Konobari' }
    },
    {
      path: '/venues-list',
      name: 'VenuesList',
      component: VenuesList,
      meta: { requiresAuth: true, headerTitle: 'Tipovi rezervacija' }
    },
    {
      path: '/admins-list',
      name: 'AdminsList',
      component: AdminsList,
      meta: { requiresAuth: true, headerTitle: 'Administratori' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = Firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('future-events')
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js